import { defineStore } from "pinia";
import { useMultiAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";

export const useCurationOtherTags = defineStore("curation-distribution-tags-other-tags-field", () => {
  const field = useMultiAdditionalServiceField({
    id: "other_tags",
    functionalGroupCode: "OTHER_TAGS",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("other_tags");

  return { ...field, hasUnpublishedChange };
});
